import { filterNulls } from './arrayUtils';

export function joinClasses(...classes: Array<string | undefined>): string {
  return filterNulls(classes).join(' ');
}
